import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ShowAllTransactionHistory from '../../components/HistoryComps/TransactionComps/ShowAllTransactionHistory';
import TransactionModalsWrapper from '../../components/HistoryComps/TransactionComps/TransactionModalsWrapper';
import MutationModalProvider from '../../contexts/MutationModalProvider';
import TransactionProvider from '../../contexts/TransactionProvider';

const Transaction = () => {
  // rendering transaction history page component here
  return (
    <>
      <PageTitle title='Transaction History' />

      <MutationModalProvider>
        <TransactionProvider>
          <ShowAllTransactionHistory />
          <TransactionModalsWrapper />
        </TransactionProvider>
      </MutationModalProvider>
    </>
  );
};

export default Transaction;
